import { Box, Link as MuiLink } from '@mui/material'
import { useMyLanguage } from 'app/_hooks'
import Image from 'next/image'
import { useMediaQuery } from '~/hooks/useMediaQuery'
import { URLConstants } from '~/libs/constants'
import browserEnv from '~/libs/env/browserEnv'

export const AppFooterStoreBadges = () => {
  const language = useMyLanguage()
  const { isMd } = useMediaQuery()

  return (
    <Box display='flex' alignItems='center' gap={isMd ? '8px' : '16px'}>
      <MuiLink href={URLConstants.appStorePage} target='_blank' sx={{ display: 'flex' }}>
        <Image
          src={`${browserEnv.NEXT_PUBLIC_ASSETS_URL}/images/footer/${language}/app_store.svg`}
          alt='App Store'
          width={87}
          height={32}
          unoptimized
          style={{ width: 'auto', height: '32px' }}
        />
      </MuiLink>
      <MuiLink href={URLConstants.googlePlayPage} target='_blank' sx={{ display: 'flex' }}>
        <Image
          src={`${browserEnv.NEXT_PUBLIC_ASSETS_URL}/images/footer/${language}/google_play_store.svg`}
          alt='Google Play'
          width={108}
          height={32}
          unoptimized
          style={{ width: 'auto', height: '32px' }}
        />
      </MuiLink>
    </Box>
  )
}
